/**
 * Normalizes a phone number to E.164 format for SMS (Twilio).
 */
export function normalizePhoneToE164(phone: string | null | undefined): string | null {
  if (!phone) {
    return null;
  }

  const cleaned = phone.replace(/[^\d+]/g, "");

  if (cleaned.startsWith("+")) {
    if (cleaned.startsWith("+1") && cleaned.length === 12) {
      return cleaned;
    }
    if (cleaned.length >= 10) {
      return cleaned;
    }
    return null;
  }

  const digits = cleaned.startsWith("1") && cleaned.length === 11 ? cleaned.slice(1) : cleaned;

  if (digits.length === 10) {
    return `+1${digits}`;
  }

  if (digits.length === 11 && digits.startsWith("1")) {
    return `+${digits}`;
  }

  return null;
}
